import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@components/empty';
import { Spinner } from '@components/spinner';

export const LoadingPlaceholder = ({ text }: { text?: string }) => (
  <Empty>
    <EmptyHeader>
      <EmptyMedia variant="icon">
        <Spinner className="size-6" />
      </EmptyMedia>
      <EmptyTitle>Loading</EmptyTitle>
      {text && <EmptyDescription>{text}</EmptyDescription>}
    </EmptyHeader>
  </Empty>
);
